export default __webpack_public_path__ + "static/media/logo-square.10699579.png";